import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getKenDetailsViaInput, getKenDetailsViaUploadFile } from './APIS'

// Initial state
const initialState = {
  kens: [] as any[],
  loading: false,
  error: null as string | null,
}

export const getKenDetailsViaInputThuck = createAsyncThunk(
  'kensDetailsSlice/getKenDetailsViaInputThuck',
  async (params: any) => {
    return await getKenDetailsViaInput(params)
  },
)

export const getKenDetailsViaUploadFileThuck = createAsyncThunk(
  'kensDetailsSlice/getKenDetailsViaUploadFileThuck',
  async (params: { body: any; isAdmin: boolean }) => {
    return await getKenDetailsViaUploadFile(params.body, params.isAdmin)
  },
)

const kensDetailsSlice = createSlice({
  name: 'kensDetailsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getKenDetailsViaInputThuck.pending, (state) => {
        state.loading = true
        state.error = null
        state.kens = []
      })
      .addCase(getKenDetailsViaInputThuck.fulfilled, (state, action) => {
        const kens = (action.payload as any).kens
        state.loading = false
        state.kens = kens || []
      })
      .addCase(getKenDetailsViaInputThuck.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Unknown error'
        state.kens = []
      })
      .addCase(getKenDetailsViaUploadFileThuck.pending, (state) => {
        state.loading = true
        state.error = null
        state.kens = []
      })
      .addCase(getKenDetailsViaUploadFileThuck.fulfilled, (state, action) => {
        const kens = (action.payload as any).kens
        state.loading = false
        state.kens = kens || []
      })
      .addCase(getKenDetailsViaUploadFileThuck.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Unknown error'
        state.kens = []
      })
  },
})

export default kensDetailsSlice.reducer
